(function (doc) {
    'use strict';
    doc.querySelectorAll('[data-okno-losowan]').forEach(function (box) {
        if (box.dataset.oknoGotowe) return;
        box.dataset.oknoGotowe = '1';
        var custom = box.querySelector('[data-okno-wlasne]');
        var select = box.querySelector('[data-okno-sync]');
        var radios = Array.prototype.slice.call(box.querySelectorAll('input[type="radio"][name="okno"]'));
        function refresh() {
            if (select) {
                var checked = radios.find(function (r) { return r.checked; });
                var value = checked ? checked.value : (custom ? custom.value : '');
                if (value && select.value !== value) {
                    if (!Array.prototype.some.call(select.options, function (o) { return o.value === value; })) select.add(new Option(value, value));
                    select.value = value;
                    select.dispatchEvent(new Event('change', {bubbles:true}));
                }
                // Select remains the single submitted value for its original controller.
                radios.forEach(function (r) { r.removeAttribute('name'); });
                select.parentElement.hidden = true;
            }
            radios.forEach(function (radio) {
                var label = radio.closest('label');
                if (label) label.hidden = radio.checked;
            });
        }
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                radios.forEach(function (other) { if (other !== radio) other.checked = false; });
                if (radio.checked && custom) custom.value = radio.value === 'all' ? '' : radio.value;
                refresh();
                if (custom && radio.checked) custom.focus({preventScroll:true});
            });
        });
        if (custom) custom.addEventListener('input', function () {
            radios.forEach(function (radio) { radio.checked = custom.value !== '' && radio.value === custom.value; });
            refresh();
        });
        refresh();
    });
})(document);
